import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'region',
    serviceName: 'auth',
    query: gql`
      query region($ids: [String]) {
        region(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
